export const emailUrl =
  "https://w2e9j471i2.execute-api.ap-south-1.amazonaws.com/dev/send-email";
export const mainUrl = "https://iedc-collab-frontend.pages.dev";
